import { render, staticRenderFns } from "./q-title.vue?vue&type=template&id=f2539260&scoped=true&"
import script from "./q-title.vue?vue&type=script&lang=js&"
export * from "./q-title.vue?vue&type=script&lang=js&"
import style0 from "./q-title.vue?vue&type=style&index=0&id=f2539260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2539260",
  null
  
)

export default component.exports